import { render } from "./high-kanban.vue?vue&type=template&id=27be349f"
import script from "./high-kanban.vue?vue&type=script&lang=js"
export * from "./high-kanban.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__